// IE 2026 10 29 / ODOO-5800 (ie-dm7 #114076: двойной тултип в колонке ответственного)
// НАТИВНАЯ ПОДСКАЗКА ОБРЕЗАННОЙ ЗАМОРОЖЕННОЙ ЯЧЕЙКИ (AttrGrid: _frozenClip / frozenClip_flush, title = полный текст ячейки).
// Было: title ставился только пустому элементу (`if (!cell.title) cell.title = text`) и не снимался никогда. wijmo переиспользует элементы ячеек под другие строки
// (прокрутка, раскрытие групп), и элемент уносил подсказку ЧУЖОЙ строки; копия в клоне замороженных колонок (.wj-frozen-clone) копирует её вместе с атрибутами.
// Наведение на такую ячейку давало ДВЕ подсказки: «продолжение» с текстом своей строки (clipOverlay) и нативную браузерную — с текстом другой строки
// (её снятие при наведении, fe.ux.clipOverlayDropTitle, срабатывает только при равенстве title тексту ячейки). Проба dev02 p086 (Баланс, колонка
// «Ступінь · відповідальний · версія»): ячейка строки «Голубничий …» несла title «◎ MD · Янюк …» другой строки.
// Теперь подсказка СВОЯ: отметка __fzTitle (текст, который поставили мы); свою подсказку обновляем под текущий текст / снимаем, когда текст не обрезан
// или элемент ушёл из замороженной области; чужие title (подсказки других механизмов) не трогаем. Выключатель fe.ux.frozenTitleOwn (дефолт ВКЛ; выкл — как было).
// Чистая логика без DOM — юнит tests/unit/frozenClipTitle.test.mjs

export const FROZEN_TITLE_FLAG = 'fe.ux.frozenTitleOwn'

const str = (v) => (v === null || v === undefined) ? '' : String(v)

// решение для элемента ячейки. cur — текущий title элемента, own — отметка __fzTitle (что ставили мы), text — полный текст ячейки сейчас,
// clipped — текст обрезан, spill — ячейка разлита (продолжение и так видно), on — выключатель.
// Выход: { set } — string: поставить title; null: снять title; undefined: не трогать. { own } — новая отметка (null — подсказка не наша)
export function frozenTitle_next(cur, own, text, clipped, spill, on = true) {
    const c = str(cur), o = own === undefined ? null : own, tx = str(text).trim()
    if (!on) return { set: (clipped && !spill && !c && tx) ? tx : undefined, own: o }   // прежнее поведение
    const mine = o !== null && c === o
    const want = (clipped && !spill) ? tx : ''
    if (want) {
        if (!c) return { set: want, own: want }
        if (mine) return { set: c === want ? undefined : want, own: want }
        return { set: undefined, own: null }   // title другого механизма — его
    }
    if (mine && c) return { set: null, own: null }
    return { set: undefined, own: c ? null : o }   // пусто (снял продолжение при наведении) — отметка остаётся; чужой title — не наш
}

// синхронная проверка при перерисовке (formatItem, оба пути): элемент несёт НАШУ подсказку, а текст ячейки уже другой (переиспользован под другую
// строку) или ячейка не в замороженной области — снять сразу, до клона замороженных колонок wijmo; обрезанную заново подпишет frozenClip_flush. true — снять
export function frozenTitle_stale(cur, own, text, frozen) {
    if (own === undefined || own === null) return false
    const c = str(cur)
    if (!c || c !== own) return false
    return !frozen || c !== str(text).trim()
}

// применение к элементу (DOM-обёртка; get/set/remove — через стандартные методы элемента)
export function frozenTitle_apply(el, text, clipped, spill, on = true) {
    if (!el) return
    const r = frozenTitle_next(el.getAttribute('title'), el.__fzTitle, text, clipped, spill, on)
    if (r.set === null) el.removeAttribute('title')
    else if (typeof r.set === 'string') el.setAttribute('title', r.set)
    el.__fzTitle = r.own
}
